import React, { useContext, useEffect, useState } from 'react'
import { Box, CircularProgress, useMediaQuery, useTheme } from '@mui/material'
import AirportsList from './AirportsList'
import { Outlet, useNavigate, useParams } from 'react-router-dom'
import CenteredContent from '../CenteredContent'
import AirportsCards from './AirportsCards'
import { useTranslation } from 'react-i18next'
import AirportsContext from '../AirportsContext'

const AirportsPage = () => {
  const { t } = useTranslation()
  const params = useParams()
  const navigate = useNavigate()
  const airports = useContext(AirportsContext)
  const [selectedAirportIcao, setSelectedAirportIcao] = useState<string | undefined>(params.airportIcao)

  const theme = useTheme()
  const screenBiggerThanMedium = useMediaQuery(theme.breakpoints.up('md'))

  useEffect(() => {
    if (params.airportIcao !== selectedAirportIcao) {
      setSelectedAirportIcao(params.airportIcao || undefined)
    }
  }, [selectedAirportIcao, params])

  useEffect(() => {
    if (airports && airports.length === 1 && !selectedAirportIcao) {
      setSelectedAirportIcao(airports[0].icao)
      navigate(airports[0].icao)
    }
  }, [selectedAirportIcao, airports, navigate])

  if (!airports) {
    return (
      <CenteredContent>
        <CircularProgress />
      </CenteredContent>
    )
  } else if (airports.length === 0) {
    return <CenteredContent sx={{ typography: 'h5' }}>{t('airports.noAirportsMessage')}</CenteredContent>
  } else if (airports.length === 1) {
    return (
      <Box sx={{ display: 'flex', width: '100%' }}>
        <Outlet />
      </Box>
    )
  } else if (!selectedAirportIcao) {
    return <AirportsCards airports={airports} />
  } else {
    return (
      <Box sx={{ display: 'flex', width: '100%' }}>
        {airports.length > 1 && screenBiggerThanMedium && (
          <AirportsList airports={airports} selectedAirportIcao={selectedAirportIcao} />
        )}
        <Box
          sx={{ display: 'flex', flex: '1 1 auto', marginLeft: screenBiggerThanMedium && airports.length > 1 ? 4 : 0 }}
        >
          <Outlet />
        </Box>
      </Box>
    )
  }
}

export default AirportsPage
